import type { SearchLang } from '@/types/api';
import {
  TranslationPillGroup,
  TranslationPill,
} from '@/components/ui/TranslationPillGroup';

type Option = { value: SearchLang; label: string };

const OPTIONS: Option[] = [
  { value: 'en', label: 'English' },
  { value: 'ur', label: 'Urdu' },
  { value: 'ar', label: 'Arabic' },
];

type Props = {
  value: SearchLang;
  onChange: (next: SearchLang) => void;
};

/**
 * Drives the `?lang=` param. In keyword mode this picks which text
 * column to search (`translation_en` / `translation_ur` / `text_ar`).
 * In semantic mode this picks which language of `ayah_embeddings` to use.
 */
export function SearchLanguageFilter({ value, onChange }: Props) {
  return (
    <TranslationPillGroup ariaLabel="Search language">
      {OPTIONS.map((opt) => (
        <TranslationPill
          key={opt.value}
          active={opt.value === value}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </TranslationPill>
      ))}
    </TranslationPillGroup>
  );
}